import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneonewaytaxiservice() {



  const cardData = {
"keyword": "Pune One Way Taxi Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune One Way Taxi Service for travelers who need affordable and convenient point-to-point transportation without paying for a return trip. Whether you are planning a business travel, airport transfer, family relocation, weekend trip, pilgrimage, or intercity journey, our cab service ensures a smooth and stress-free ride. With experienced drivers who are well-versed with highways and intercity routes, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to multiple destinations. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way booking options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and cost-effective one-way travel experience.",

"topPlaces": [
  {
    "title": "Mumbai",
    "description":
      "Mumbai is one of the most popular destinations for one-way taxi service from Pune, known for business hubs, tourism attractions, beaches, Bollywood culture, and financial centers. Travelers frequently use Pune to Mumbai one-way cabs for corporate and personal trips."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is a major pilgrimage and wine capital of India known for Trimbakeshwar Jyotirlinga, Kumbh Mela, vineyards, and religious tourism. It is a common one-way taxi destination from Pune."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a world-famous pilgrimage destination dedicated to Sai Baba. Many devotees book one-way cabs from Pune for darshan, spiritual visits, and quick temple trips."
  },
  {
    "title": "Aurangabad",
    "description":
      "Aurangabad is a historical city known for Ajanta and Ellora Caves, Bibi Ka Maqbara, and rich Mughal-Maratha heritage, making it a popular one-way travel destination from Pune."
  },
  {
    "title": "Solapur",
    "description":
      "Solapur is an important industrial and religious city known for Siddheshwar Temple and textile industry, frequently connected through Pune one-way taxi services."
  },
  {
    "title": "Kolhapur",
    "description":
      "Kolhapur is famous for Mahalaxmi Temple, historical forts, and cultural heritage. It is a popular destination for one-way cab travel from Pune."
  },
  {
    "title": "Satara",
    "description":
      "Satara is known for Kaas Plateau, Ajinkyatara Fort, and scenic Sahyadri landscapes, making it a short-distance one-way taxi destination from Pune."
  },
  {
    "title": "Lonavala",
    "description":
      "Lonavala is a popular hill station near Pune known for waterfalls, green valleys, and scenic viewpoints, frequently booked for one-way leisure trips."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal destination near Mumbai known for beaches, forts, and weekend tourism, often used for Pune one-way cab coastal travel."
  },
  {
    "title": "Maharashtra Highway Network Route",
    "description":
      "Pune one-way taxi services connect major cities and towns across Maharashtra through well-maintained highways, offering smooth, flexible, and cost-effective intercity travel options."
  }
],



services: [
  {
    name: "Pune One Way Taxi",
    description: "Pune one way taxi service provides reliable transportation for passengers traveling from Pune to nearby cities and outstation destinations with comfortable vehicles and experienced drivers. Vehicles are suitable for long-distance highway travel ensuring smooth and timely journeys for families, tourists, corporate travelers, and local passengers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way taxi reservations."
  },
  {
    name: "One Way Cab Pune",
    description: "One way cab Pune service offers dependable transportation for outstation travel with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, family travel, tourism, and intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune Drop Taxi Service",
    description: "Pune drop taxi service provides comfortable transportation for passengers requiring direct drop services from Pune to various destinations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth travel journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for business travelers, tourists, and family travel requirements. Flexible booking options allow convenient drop taxi reservations."
  },
  {
    name: "One Side Cab Pune",
    description: "One side cab Pune service offers reliable transportation with comfortable vehicles and professional drivers for passengers requiring single-route travel from Pune. Vehicles provide smooth city and highway travel suitable for tourism, business visits, and family travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available directly from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy one-side cab reservations."
  },
  {
    name: "Intercity One Way Taxi Pune",
    description: "Intercity one way taxi Pune service provides dependable transportation solutions for one-way travel between Pune and nearby cities. Vehicles are suitable for long-distance travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, tourism trips, and family outstation travel. Flexible booking options allow convenient intercity taxi reservations."
  },
  {
    name: "Cheap One Way Taxi Pune",
    description: "Cheap one way taxi Pune service provides transparent and economical transportation for travelers needing affordable one-way travel services from Pune. Travelers can enjoy smooth journeys with experienced drivers familiar with highway routes and traffic conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient low-cost taxi reservations."
  },
  {
    name: "Best One Way Cab Pune",
    description: "Best one way cab Pune service provides economical and comfortable transportation for travelers planning one-way airport transfers and outstation journeys from Pune. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "SUV One Way Taxi Pune",
    description: "SUV one way taxi Pune service offers spacious transportation for families and groups traveling from Pune to various destinations. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for family outings and outstation travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV one-way taxi reservations."
  },
  {
    name: "Innova One Way Cab Pune",
    description: "Innova one way cab Pune service provides premium SUV transportation for passengers seeking comfortable and reliable outstation travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, business trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova one-way cab reservations."
  },
  {
    name: "Sedan One Way Taxi Pune",
    description: "Sedan one way taxi Pune service offers economical and comfortable transportation for solo travelers, couples, and small families traveling from Pune to outstation destinations. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for one-way travel journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan taxi reservations."
  },
  {
    name: "Pune Outstation One Way Cab",
    description: "Pune outstation one way cab service offers dependable transportation for passengers planning direct outstation travel from Pune. Comfortable vehicles ensure smooth highway travel suitable for tourism, business travel, and family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation one-way cab reservations."
  },
  {
    name: "Pune Long Distance One Way Taxi",
    description: "Pune long distance one way taxi service provides reliable transportation for travelers planning long-distance journeys from Pune to various cities and destinations. Comfortable vehicles ensure smooth and safe travel suitable for tourists, families, business travelers, and airport visitors. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient long-distance taxi reservations."
  },
  {
    name: "Instant One Way Cab Pune",
    description: "Instant one way cab Pune service offers comfortable transportation for passengers looking for immediate one-way travel services from Pune. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for urgent travel, business trips, family tours, and outstation travel requirements. Flexible booking options allow convenient instant cab reservations."
  },
  {
    name: "Pune One Way Booking Taxi",
    description: "Pune one way booking taxi service provides dependable transportation for passengers planning advance one-way travel reservations from Pune. Comfortable vehicles ensure smooth highway travel suitable for tourism, airport visits, and corporate travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-way booking taxi reservations."
  },
  {
    name: "Express One Way Cab Pune",
    description: "Express one way cab Pune service provides affordable and convenient fast transportation for passengers traveling between Pune and nearby cities. Vehicles ensure reliable highway travel with experienced drivers offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for business travelers, tourists, and one-way outstation travel requirements. Flexible booking options allow convenient express cab reservations."
  }
],

tableData: [
  ["Pune One Way Taxi", "One Way Cab Pune"],
  ["Pune Drop Taxi Service", "One Side Cab Pune"],
  ["Intercity One Way Taxi Pune", "Cheap One Way Taxi Pune"],
  ["Best One Way Cab Pune", "SUV One Way Taxi Pune"],
  ["Innova One Way Cab Pune", "Sedan One Way Taxi Pune"],
  ["Pune Outstation One Way Cab", "Pune Long Distance One Way Taxi"],
  ["Instant One Way Cab Pune", "Pune One Way Booking Taxi"],
  ["Express One Way Cab Pune", "Pune One Way Taxi"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune One Way Taxi Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune One Way taxi service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe travel experiences."
      },
      {
        WhyChooseheading: "Affordable One Way Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune One Way taxi pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 One Way Cab Availability",
        WhyChoosedescription: "Our Pune One Way taxi service operates 24 hours a day for airport transfers, outstation travel, business trips, family travel, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable local and outstation travel experiences."
      },
      {
        WhyChooseheading: "Flexible One Way Travel Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Pune to Mumbai one-way taxi, airport drops, intercity travel, corporate travel, and customized one-way taxi bookings."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, tourists, and corporate travelers."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with major highway and city routes, ensuring safe driving, smooth travel, and timely drop services for every one-way journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune One Way taxi service?", answer: "Pune One Way taxi service provides comfortable taxi transportation for one-side travel between Pune and various local or outstation destinations." },
    { question: "Is Pune One Way taxi service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune One Way taxi service." },
    { question: "Which vehicles are available for one-way travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book one-way taxi service for outstation travel?", answer: "Yes, customers can book one-way taxi services for local, airport, and outstation travel." },
    { question: "Do you provide airport one-way taxi service?", answer: "Yes, Shivai Travels provides one-way airport pickup and airport drop taxi services." },
    { question: "Are all Pune One Way taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune One Way taxi service online?", answer: "Yes, customers can easily book Pune One Way taxi service online or through phone booking." },
    { question: "Do you provide taxis for family and corporate travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family travel and corporate transportation." },
    { question: "Are Pune One Way taxi fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune One Way taxi service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akash Deshmukh",
      feedback:
        "Booked Pune One Way taxi service with Shivai Travels. On-time pickup, comfortable vehicle, and smooth travel experience.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Sneha Kulkarni",
      feedback:
        "Excellent Pune One Way taxi service. Affordable pricing, clean cab, and professional driver support.",
      rating: 5
    }
  ];











  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune One Way Taxi Service",
  "image": "https://shivaitravels.com/assets/images/pune-one-way-taxi.jpg",
  "description": "Book Pune One Way Taxi Service for affordable and convenient drop travel to outstation and intercity destinations. Shivai Travels offers instant one-way cab booking with sedan, SUV, Innova, and luxury cab options available 24x7 for long-distance travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-one-way-taxi-service"
  }
};




  return (
    <div>


<Helmet>
  <title>Pune One Way Taxi Service | Drop Cab Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune One Way Taxi Service for affordable drop trips to any destination. Instant booking available with sedan, SUV, Innova, and luxury cabs for intercity and outstation travel."
  />

  <meta
    name="keywords"
    content="pune one way taxi, one way cab pune, pune drop taxi service, one side cab pune, intercity one way taxi pune, cheap one way taxi pune, best one way cab pune, suv one way taxi pune, innova one way cab pune, sedan one way taxi pune, pune outstation one way cab, pune long distance one way taxi, instant one way cab pune, pune one way booking taxi, express one way cab pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneonewaytaxiservice;